import {AxiosInstance} from "axios";
import {FrequentationWeek, FrequentationYear} from "@/core/interfaces/Frequentation";

/**
 * Expected attendance of the authenticated user's pharmacy, computed by the
 * HDS from its sale history. Both calls answer an empty list when the
 * pharmacy is inactive or its history is too thin to grade; that emptiness
 * is turned into null here so callers test one thing.
 */
const FrequentationResource = (hdsClient: AxiosInstance) => {
    const present = <T>(data: T | unknown[]): T | null => (Array.isArray(data) ? null : data);

    return {
        /**
         * The expected load of the week starting on the given Monday (Y-m-d).
         */
        async week(monday: string): Promise<FrequentationWeek | null> {
            const response = await hdsClient.get('healthcenter/frequentation', {params: {week: monday}});

            return present<FrequentationWeek>(response.data.data);
        },

        /**
         * The actual activity of the last 52 weeks.
         */
        async year(): Promise<FrequentationYear | null> {
            const response = await hdsClient.get('healthcenter/frequentation/year');

            return present<FrequentationYear>(response.data.data);
        }
    };
};

export default FrequentationResource;
